import { render } from "./TextEditor.vue?vue&type=template&id=2b7374e5&scoped=true&ts=true"
import script from "./TextEditor.vue?vue&type=script&lang=ts"
export * from "./TextEditor.vue?vue&type=script&lang=ts"

import "./TextEditor.vue?vue&type=style&index=0&id=2b7374e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7374e5"]])

export default __exports__